/**
 * AndVHistogram - 直方图组件
 * 基于 Ant Design Charts Histogram
 */
import React from 'react';
import { Histogram } from '@ant-design/plots';
import { withBaseChart } from '../base/BaseChart';
import type { AndVHistogramProps } from '../base/types';

const DEFAULT_HISTOGRAM_DATA = [
  { value: 1.2 },
  { value: 3.4 },
  { value: 3.7 },
  { value: 4.3 },
  { value: 5.2 },
  { value: 5.8 },
  { value: 6.1 },
  { value: 6.5 },
  { value: 6.8 },
  { value: 7.2 },
  { value: 7.5 },
  { value: 8.0 },
  { value: 8.4 },
  { value: 9.1 },
];

const HistogramWithBase = withBaseChart<AndVHistogramProps>(Histogram, {
  chartType: 'AndVHistogram',
  defaultHeight: 300,
  defaultData: DEFAULT_HISTOGRAM_DATA,
});

export const AndVHistogram: React.FC<AndVHistogramProps> = (props) => {
  const {
    binField = 'value',
    binWidth,
    binNumber,
    colorField,
    channel,
    ...baseProps
  } = props;

  const chartProps: Record<string, unknown> = {
    ...baseProps,
    binField,
  };

  if (binWidth !== undefined) chartProps.binWidth = binWidth;
  if (binNumber !== undefined) chartProps.binNumber = binNumber;
  if (colorField) chartProps.colorField = colorField;
  if (channel) chartProps.channel = channel;

  return <HistogramWithBase {...chartProps} />;
};

export type { AndVHistogramProps };
export default AndVHistogram;
